<template>
  <div
    class="country_drop_container"
    :class="[readonly ? 'cursor-default' : 'pointer']"
    v-click-outside="() => (isOpen = false)"
    @click="readonly ? null : (isOpen = !isOpen)"
  >
    <span>{{ countryName ? countryName : lang.country }}</span>
    <inline-svg v-if="!readonly" :src="require('@/assets/icons/Vector.svg')" />
    <div class="country_drop" v-if="isOpen">
      <div class="seach-box">
        <input
          v-model="search"
          type="text"
          class="form-input"
          :placeholder="lang.search"
          @click.stop=""
        />
      </div>

      <div v-if="!filterCountries.length" class="not-found">
        {{ lang.notFount }}
      </div>
      <div v-else class="country_drop_items">
        <div
          v-for="(country, index) in filterCountries"
          :key="index"
          @click="$emit('changeCountry', country)"
        >
          {{ country.countryName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import InlineSvg from "vue-inline-svg";

export default {
  name: "SelectCountry",
  components: { InlineSvg },
  props: ["countryName", "countries", "lang", "readonly"],
  data() {
    return {
      isOpen: false,
      search: "",
    };
  },
  computed: {
    filterCountries() {
      if (!this.search) {
        return this.countries;
      }
      return this.countries.filter((item) =>
        item.countryName.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  directives: { ClickOutside },
};
</script>

<style lang="scss" scoped>
[dir="rtl"]
  .country_drop_container
  .country_drop
  .seach-box
  .form-input::placeholder {
  text-align: right;
}
.light {
  .country_drop_container .country_drop .seach-box .form-input {
    border-color: #fff;
  }
  .title {
    color: var(--primary);
  }
}

.country_drop_container {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #fff;
  padding: 0 10px;
  border-radius: 4px;
  // border: 1px solid var(--border);
  background-color: #060d35;
  user-select: none;
  border-radius: 4px;
  cursor: pointer;

  .country_drop {
    position: absolute;
    width: 100%;
    top: 45px;
    background: #060d35;
    z-index: 2;
    left: -1px;
    text-align: left;
    font-size: 14px;
    color: #fff;
    cursor: default;
    border-radius: 4px;

    .seach-box {
      padding: 16px;
      .form-input {
        // border-color: var(--border);
        background-color: #060d35;
        color: #fff;
        direction: ltr;
        width: 100%;
      }
    }
    .country_drop_items {
      max-height: 180px;
      overflow: auto;
      width: 100%;
      padding: 16px;
      div {
        cursor: pointer;
      }
    }
    .not-found {
      cursor: default;
      padding: 16px;
    }
  }
}
</style>
